import { ReactElement } from 'react'
import styled, { keyframes } from 'styled-components'

const loaderAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Loader = styled.div`
  border-top-width: 1vh;
  border-top-style: solid;
  border-right: 1vh solid #f3f3f3;
  border-bottom: 1vh solid #f3f3f3;
  border-left: 1vh solid #f3f3f3;
  border-radius: 50%;
  height: 4.5vh;
  width: 4.5vh;
  margin-bottom: 1.5vh;
  animation-name: ${loaderAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
`
function Spinner (): ReactElement {
  return <Loader className="tolology-LoadingAnimation" />
}

export default Spinner
